module.exports = __webpack_public_path__ + "img/vip_wenbv2.99096ff2.svg";